import { createFileRoute } from '@tanstack/react-router';

import { CompConfigPage } from '../modules/location-comp-config/ui/pages/CompConfigPage';

// NOTE: .index.tsx suffix is REQUIRED here (same pattern as ticket-types-config + niche-config + tariff + zones + checkin-config routes).
// Without the .index suffix, TanStack Router treats the file as a layout component
// and wraps child routes instead of rendering the page. See JQ4-11 WU-13 gotcha.
export const Route = createFileRoute(
  '/_authenticated/dashboard/locations/$locationId/comp-config/',
)({
  component: CompConfigPage,
  staticData: {
    breadcrumb: ['Manage', 'Locations', 'Comps'],
  },
});
